<template>
  <div class="text-start">

    <nav class="border-b border-gray-300 px-2 md:px-0 mb-4 py-2" v-if="breadcrumb">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <router-link :to="{name:'home'}">Home</router-link>
            <span class="mx-2">/</span>
            <router-link :to="{name:'service_plans'}">Service plans</router-link>
            <span class="mx-2">/</span>
            <span>New service plan</span>
          </div>
          <div class="text-xl">
            New service plan
          </div>
        </div>
      </div>
    </nav>
    <div class="pb-4">
      <div class="bg-white p-4 border rounded shadow-sm">
        <div class="" v-if="!this.free_internet">
          <label class="block text-sm  mb-1">Plan name<span class="text-red-700">*</span></label>
          <input aria-label="Plan name" type="text" required v-model="name" :class="inputClass"
                 placeholder="Plan name"/>
        </div>
        <div class="flex my-3 justify-between">
          <div class="w-full mr-2">
            <label class="block text-sm leading-5  mb-1">Plan type<span class="text-red-700">*</span></label>
            <select :class="inputClass" class="bg-transparent" v-model="plan_type">
              <option value="Unlimited">Unlimited</option>
              <option value="Limited">Limited</option>
            </select>
          </div>
          <div v-if="plan_type == 'Limited'" class="w-full ml-2">
            <label class="block text-sm leading-5 mb-1 ">Limit type<span class="text-red-700">*</span></label>
            <select :class="inputClass" class="bg-transparent" v-model="plan_limit_type">
              <option value="Time">Time limit</option>
              <option value="Data">Data limit</option>
              <option value="Both">Both</option>
            </select>
          </div>
        </div>

        <div v-if="plan_type === 'Limited'">
          <div class="flex my-3 justify-between">
            <div class="w-full mr-2" v-if="plan_limit_type === 'Data' || plan_limit_type === 'Both'">
              <label class="block text-sm leading-5 font-medium text-gray-700">Data Limit</label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input :class="inputClass" v-model="usage_limit" placeholder="1">
                <div class="absolute inset-y-0 right-0 flex items-center">
                  <select aria-label="Currency" v-model="usage_limit_unit"
                          class="form-select h-full py-0 pl-2 pr-7 border-transparent bg-transparent mr-2 sm:text-sm sm:leading-5">
                    <option value="MBs">Mbs</option>
                    <option value="GBs">Gbs</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="w-full ml-2" v-if="plan_limit_type === 'Time' || plan_limit_type === 'Both'">
              <label class="block text-sm leading-5 ">Time limit</label>
              <div class="mt-1 relative rounded-md shadow-sm">
                <input v-model="time_limit" type="number" :class="inputClass" placeholder="1">
                <div class="absolute inset-y-0 right-0 flex items-center">
                  <select v-model="time_limit_unit"
                          class="form-select h-full py-0 pl-2 pr-7 border-transparent bg-transparent mr-2 sm:text-sm sm:leading-5">
                    <option value="Mins">Minutes</option>
                    <option value="Hrs">Hours</option>
                    <option value="Days">Days</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="block md:flex my-3 justify-between">
          <div class="w-full md:mr-2">
            <label class="block text-sm mb-1 leading-5 ">Bandwidth Policy</label>
            <select :class="inputClass" class="bg-transparent" v-model="bandwidth_policy">
              <option value="">Unlimited bandwidth</option>
              <option :value="policy.id" v-for="policy in bandwidthPolicies" v-bind:key="policy.id">{{ policy.name }}
              </option>
            </select>
          </div>
          <div class="w-full md:ml-2">
            <label class="mb-1 block text-sm leading-5 ">Simultaneous connections</label>
            <input type="text" required v-model="simultaneous_connections" :class="inputClass" placeholder="1"/>
          </div>
        </div>
        <div class="block md:flex my-3 justify-between">
          <div class="w-full md:mr-2" v-if="!this.free_internet">
            <label class="block mb-1 text-sm leading-5 ">Price (Ksh)</label>
            <input type="text" required v-model="price" :class="inputClass" placeholder="100"/>
          </div>
          <div class="w-full md:ml-2">
            <label class="mb-1 block text-sm leading-5 ">Validity</label>
            <div class="relative rounded-md shadow-sm">
              <input v-model="validity" type="number" :class="inputClass" placeholder="1">
              <div class="absolute inset-y-0 right-0 flex items-center">
                <select v-model="validity_units"
                        class="form-select h-full py-0 pl-2 pr-7 border-transparent bg-transparent mr-2 sm:text-sm sm:leading-5">
                  <option value="Mins">Minutes</option>
                  <option value="Hrs">Hours</option>
                  <option value="Days">Days</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="my-3">
          <label class="block text-sm leading-5 mb-1">Description</label>
          <textarea v-model="description" class="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900
                      rounded-b-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
                    placeholder="Describe..."></textarea>
        </div>
        <div class="hidden">
          <label class="block text-gray-500 font-bold">
            <input class="mr-2 leading-tight" v-model="free_internet" type="checkbox">
            <span class="text-sm">Default free internet plan</span>
          </label>
        </div>
        <div class="mt-6">
          <button type="submit" v-if="$store.getters.can(planId != null ? 'create_service_plan': 'edit_service_plan')"
                  v-on:click="saveServicePlan" class="rounded px-4 md:px-5 xl:px-4 py-2  bg-teal-500 hover:bg-teal-600 md:text-lg leading-tight
                       xl:text-base text-white">
            {{ planId != null ? 'Update' : 'Create' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import GraphQl from "@/services/graphql.service";

export default {
  name: "CreateServicePlan",
  components: {},
  data() {
    return {
      bandwidthPolicies: [],
      name: this.free ? 'Free plan' : null,
      plan_type: 'Unlimited',
      plan_limit_type: 'Time',
      time_limit: null,
      bandwidth_policy: '',
      time_limit_unit: 'Mins',
      usage_limit: null,
      usage_limit_unit: "MBs",
      simultaneous_connections: 1,
      validity: 1,
      validity_units: 'Hrs',
      price: 0,
      code: null,
      free_internet: false,
      description: '',
      loading: false,
      errors: [],
      inputClass: 'appearance-none block w-full text-gray-700 border border-gray-300 rounded py-2 px-4 leading-tight focus:outline-none focus:border-gray-500'
    }
  },
  props: {
    title: String,
    free: String,
    planId: String,
    breadcrumb: {type: Boolean, default: true}
  },
  watch: {
    planId: function () {
      this.getServicePlan()
    }
  },
  mounted() {
    this.free_internet = this.free != null;
    this.getServicePlan()
  },
  methods: {
    getServicePlan() {
      GraphQl.sendRequest('{bandwidthPolicies{id name}}')
          .then(response => {
            this.bandwidthPolicies = response.bandwidthPolicies;
          })
      if (this.planId)
        GraphQl.sendRequest('{servicePlan(id: "' + this.planId + '"){id code name description free_internet bandwidth_policy_id time_limit time_limit_unit usage_limit usage_limit_unit simultaneous_connections validity validity_units price}}')
            .then(response => {
              this.name = response.servicePlan.name;
              this.plan_type = response.servicePlan.time_limit == null && response.servicePlan.usage_limit == null ? 'Unlimited' : 'Limited';
              this.plan_limit_type = 'Both';
              this.time_limit = response.servicePlan.time_limit;
              this.bandwidth_policy = response.servicePlan.bandwidth_policy_id;
              this.time_limit_unit = response.servicePlan.time_limit_unit;
              this.usage_limit = response.servicePlan.usage_limit;
              this.usage_limit_unit = response.servicePlan.usage_limit_unit;
              this.simultaneous_connections = response.servicePlan.simultaneous_connections;
              this.validity = response.servicePlan.validity;
              this.validity_units = response.servicePlan.validity_units;
              this.price = response.servicePlan.price;
              this.code = response.servicePlan.code;
              this.free_internet = response.servicePlan.free_internet;
              this.description = response.servicePlan.description;
            })
    },
    saveServicePlan() {
      if (!this.free_internet && this.price < 1) {
        this.$root.$emit('alert_error', ["Service plan price can not be less than Ksh 1 "]);
        return;
      }
      let params = 'name: "' + this.name + '", ' +
          (this.planId != null ? 'id:"' + this.planId + '" ' : '') +
          'bandwidth_policy_id: "' + this.bandwidth_policy + '",' +
          'time_limit: ' + this.time_limit + ',' +
          'time_limit_unit: "' + this.time_limit_unit + '",' +
          'usage_limit: ' + this.usage_limit + ', ' +
          'usage_limit_unit: "' + this.usage_limit_unit + '", ' +
          'simultaneous_connections: ' + this.simultaneous_connections + ', ' +
          'validity_units: "' + this.validity_units + '", ' +
          'price: ' + this.price + ', ' +
          'free_internet: ' + this.free_internet + ', ' +
          'description: "' + this.description + '",' +
          'code: "' + this.code + '",' +
          'validity: ' + this.validity + ', ';

      GraphQl.sendRequest('mutation{createOrUpdateServicePlan(' + params + '){code message}}')
          .then(response => {
            this.$root.$emit(response.createOrUpdateServicePlan.code === 200 ? 'alert_success' : 'alert_error', [response.createOrUpdateServicePlan.message]);
          })
    }
  }
}
</script>
<style scoped>
</style>